const modules = import.meta.glob('./shapes/*.mjs', {eager: true})

const shapes = Object.fromEntries(
    Object.values(modules)
        .map(Object.entries)
        .flat()
)

export default () => {
    const extensions = map => {
        return {
            getNodeBoxStyle(node) {
                const _n = this.nodeProxy(node)

                const {
                    interBoxBackgroundColor,
                    outerBoxBackgroundColor,
                } = {
                    ..._n.getStyle(),
                    ...node.data.style,
                }

                return {
                    interBoxBackgroundColor,
                    outerBoxBackgroundColor,
                }
            },

            getNodeLineStyle(node) {
                const _n = this.nodeProxy(node)

                const {
                    leadingLineColor,
                    leadingLineWidth,
                    trailingLineColor,
                    trailingLineWidth,
                } = {
                    ..._n.getStyle(),
                    ...node.data.style,
                }

                return {
                    leadingLineColor,
                    leadingLineWidth,
                    trailingLineColor,
                    trailingLineWidth,
                }
            },

            getNodeShape(node, textRect) {
                const style = this.getNodeShapeStyle(node)
                return shapes[style.shape](textRect, style)
            },

            getNodeShapeStyle(node) {
                const _n = this.nodeProxy(node)

                const {
                    backgroundColor,
                    borderColor,
                    borderWidth,
                    shape,
                } = {
                    ..._n.getStyle(),
                    ...node.data.style,
                }

                return {
                    backgroundColor,
                    borderColor,
                    borderWidth,
                    shape,
                }
            },

            getNodeTextStyle(node) {
                const _n = this.nodeProxy(node)

                const {
                    fontSize,
                    fontStyle,
                    fontWeight,
                    textAlign,
                    textColor,
                    textDecoration,
                } = {
                    ..._n.getStyle(),
                    ...node.data.style,
                }

                return {
                    color: textColor,
                    fontSize,
                    fontStyle,
                    fontWeight,
                    textAlign,
                    textDecoration,
                }
            },
        }
    }

    return {extensions}
}
